export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center h-20 gap-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/b196c507a80906689b7f29bbcaddbab4/ac6de51316de6ac073326ecce368c7b9.png"
              alt="iTalent V-Series Logo"
              className="h-12 sm:h-14 w-auto"
            />
          </div>

          {/* Discord Button */}
          <a
            href="https://discord.gg/Km5mRWrxMm"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-6 py-2.5 bg-[#5865F2] hover:bg-[#4752C4] text-white font-semibold rounded-lg transition-all duration-300 text-sm sm:text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-discord-line text-xl"></i>
            <span>Entrar no Discord</span>
          </a>
        </div>
      </div>
    </header>
  );
}
